import styled from 'styled-components';

const Strikethrough = styled.span`
  position: relative;

  &:before {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid currentColor;
    transform: rotate(-15deg);
  }
`;

export default Strikethrough;
